import { Component, computed } from '@angular/core';
import { MessageBaseComponent } from '../message-base/message-base.component';

@Component({
  selector: 'notifications',
  templateUrl: '../message-base/message-base.component.html',
  standalone: false
})
export class NotificationsComponent extends MessageBaseComponent {
  constructor () {
    super();
    this.channel = "Notification";
    this.filteredMessages = computed(() => {
      return this.messages().filter(
        message => (this.priority() === 0 || message.priority === this.priority())
      );
    });
    this.getMessages(this.channel, this.session.race._id);
  };

};
